export enum LINK_TYPE {
    SSO_LINK = 'sso-link',
    SSO_QUICK_LINK = 'sso-quick-link',
    SSO_BUTTON = 'sso-button',
    SSO_SECONDARY_BUTTON = 'sso-secondary-button'
}

export interface QuickLink {
    isNewTab: string;
    url: string;
    ssoType: string;
    label: string;
    linkType?: LINK_TYPE;
    descriptionHtml?: string;
}